import { useLocation } from 'react-router-dom';

import {
  normalizeJudgeSearchFiltersToApiParams,
  CourtSearchPage,
  useJudgeSearch,
  useQueryParams,
} from '../shared';
import { type JudgeSearchResponse } from '../types';

import {
  JudgeSearchForm,
  type JudgeSearchFormData,
  type JudgeSearchType,
} from './JudgeSearchForm';
import { JudgeSearchResults } from './JudgeSearchResults';

const JUDGE_SEARCH_QUERY_PREFIX_MAP: Record<string, JudgeSearchType> = {
  'name:': 'name',
  'court:': 'court',
  'appointedBy:': 'appointedBy',
};

export const JudgeSearch = () => {
  const { search } = useLocation();
  const queryParams = useQueryParams(search);
  const query = queryParams.get('query') || '';
  const exactMatchParam = queryParams.get('exact_match');
  const initialExactMatch = exactMatchParam !== 'false';

  const normalizeFilters = (filters: unknown) =>
    normalizeJudgeSearchFiltersToApiParams(
      filters as Parameters<typeof normalizeJudgeSearchFiltersToApiParams>[0]
    );

  return (
    <CourtSearchPage<JudgeSearchResponse, JudgeSearchFormData, JudgeSearchType>
      queryPrefixMap={JUDGE_SEARCH_QUERY_PREFIX_MAP}
      normalizeFilters={normalizeFilters}
      useSearchHook={useJudgeSearch}
      initialQuery={query}
      initialExactMatch={initialExactMatch}
      SearchForm={JudgeSearchForm}
      ResultsComponent={JudgeSearchResults}
    />
  );
};
